import {types} from './types';

const setGetCreditHistoryAction = (payload) => {
    return {
        type: types.SET_LIST_CREDIT_HISTORY,
        payload,
      }
}

export {
  setGetCreditHistoryAction
}
